import React from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { storeUser } from '../../store';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

const configReader = require('../../config');


const LoginInternal = ({ isLoggedIn, api }) => {
  if (isLoggedIn) {
    return <Navigate to='/' replace />;
  }
  const { googleLoginClientId } = configReader.get();

  return (
    <LayoutContext.Consumer>
      {() => (
        <div style={{ marginTop: '20px' }} className='content-width-limiter-narrow'>
          <PageTop
            documentTitle='Login page'
            documentDescription='Login page'
          />
          Please login with google to access the admin panel
          <br />
          <br />

        <GoogleOAuthProvider clientId={googleLoginClientId}>
          <GoogleLogin
            onSuccess={async ({ credential, clientId }) => {
              configReader.get();
              await api.profiles.loginGoogle(credential, clientId);
              const user = await api.profiles.getUser();
              storeUser(user);

              // TODO remove, ensure the component gets rerendered
              // TODO ensure to also load the categories whebn removing the locationi reload
              window.location.reload();
            }}
            onError={() => {
              alert('Login Failed');
            }}
          />
        </GoogleOAuthProvider>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

const Login = withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(LoginInternal));

Login.requiresLogin = false;
Login.propTypes = { isLoggedIn: PropTypes.bool };

export default Login;